import { Dialog as MuiDialog } from '@mui/material';
import { useEffect, useState } from 'react';

import {
  DialogContentStyled,
  DialogTitleStyled,
  DialogActionsStyled,
  WarningIconStyled,
  DialogContentTextStyled,
} from './DialogStyled';

export interface DialogProps {
  testId?: string;
  isOpen: boolean;
  title: string | JSX.Element | JSX.Element[];
  message: string | JSX.Element | JSX.Element[];
  children: JSX.Element | JSX.Element[];
  showWarningIcon?: boolean;
}

export const Dialog = ({
  testId = 'dialog',
  isOpen,
  title,
  message,
  children,
  showWarningIcon = false,
}: DialogProps) => {
  const [dialogNode, setDialogNode] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isOpen && dialogNode) {
      dialogNode.querySelector('button')?.focus();
    }
  }, [isOpen, dialogNode]);

  const handleRefChange = (node: HTMLDivElement | null) => setDialogNode(node);

  return (
    <MuiDialog
      ref={handleRefChange}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      data-testid={testId}
      open={isOpen}
      PaperProps={{ sx: { width: 288, maxWidth: '100%' } }}
    >
      <DialogTitleStyled id="dialog-title">
        {showWarningIcon && <WarningIconStyled data-testid="warning-icon" />}
        {title}
      </DialogTitleStyled>
      <DialogContentStyled>
        <DialogContentTextStyled id="modal-description">
          {message}
        </DialogContentTextStyled>
      </DialogContentStyled>
      <DialogActionsStyled>{children}</DialogActionsStyled>
    </MuiDialog>
  );
};
